import React from 'react';
import { Box, ShimmerBox, Text } from '@common-fe/common-fe';

interface PreloaderRowProps {
  testId: string;
}

const PreloaderRow: React.FC<PreloaderRowProps> = ({ testId }) => (
  <Box direction="row" fill justify="between" data-testid={testId}>
    <ShimmerBox width="86px" height="20px" round="checkboxRound" />
    <ShimmerBox width="160px" height="20px" round="checkboxRound" />
  </Box>
);

const LEFT_COLUMN_ROWS_COUNT = 6;
const RIGHT_COLUMN_ROWS_COUNT = 5;

const EmployerPlanDetailsPreloader = () => {
  return (
    <Box
      pad={{
        vertical: 'spacing24',
        horizontal: 'spacing16',
      }}
      background="canvas"
      round="container2Round"
      height="300px"
      border={{ size: '1px', color: 'border2' }}
      direction="column"
      data-testid="employer-plan-details_loading"
    >
      <Text data-testid="employer-plan-details_title" weight={700}>
        Plan details & deadlines
      </Text>
      <Box direction="row" margin={{ top: 'spacing8' }}>
        <Box direction="column" gap="spacing16" fill data-testid="employer-plan-details_loading-left-column">
          {Array.from({ length: LEFT_COLUMN_ROWS_COUNT }).map((_, index) => (
            <PreloaderRow key={index} testId={`employer-plan-details_loading-left-row-${index}`} />
          ))}
        </Box>
        <div>
          <Box
            height="100%"
            width="2px"
            background="border2"
            round="smallRound"
            margin={{ horizontal: 'spacing24' }}
            data-testid="employer-plan-details_loading-divider"
          />
        </div>
        <Box direction="column" gap="spacing16" fill data-testid="employer-plan-details_loading-right-column">
          {Array.from({ length: RIGHT_COLUMN_ROWS_COUNT }).map((_, index) => (
            <PreloaderRow key={index} testId={`employer-plan-details_loading-right-row-${index}`} />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default EmployerPlanDetailsPreloader;
